<div class="h-100 overflow-hidden">
  <div class="d-flex flex-column overflow-hidden h-100">
    <form [formGroup]="detailsForm">
      <div class="row mb-3">
        <div class="col-4">
          <div class="input-label">Identifier</div>
          <qualifiers formControlName="qualifier" [isFullInterface]="true">
          </qualifiers>
        </div>
        <div
          class="col-4"
          [ngbTooltip]="
            detailsForm.get('id')?.errors?.required
              ? 'This field is required'
              : 'Identifier ID should be unique and its length should be valid'
          "
          [disableTooltip]="!detailsForm.get('id')?.errors"
          container="body"
          tooltipClass="tooltip-error"
          placement="bottom"
        >
          <div class="input-label">ID</div>

          <input
            type="text"
            placeholder="Enter Id"
            class="input"
            formControlName="id"
            [(ngModel)]="idValue"
            (ngModelChange)="onIdChange($event)"
            [maxLength]="getMaxLength()"
          />

          <!-- Error Messages -->
          <div
            *ngIf="
              detailsForm.get('id')?.touched && detailsForm.get('id')?.invalid
            "
          >
            <small
              *ngIf="detailsForm.get('id')?.errors?.required"
              style="color: red; font-size: 12px"
              >ID is required.</small
            >
            <small
              *ngIf="detailsForm.get('id')?.errors?.invalidIdLength"
              style="color: red; font-size: 12px"
            >
              {{ detailsForm.get('id')?.errors?.invalidIdLength }}
            </small>
          </div>
        </div>
        <div class="col-4">
          <button
            type="button"
            class="button ml-auto"
            (click)="addProviderDetails()"
            [disabled]="detailsForm.invalid || isLoading || isReadOnly"
          >
            {{ isProviderDetailEdit ? 'Modify' : 'Add' }} Details
          </button>
        </div>
      </div>
    </form>

    <div class="standart-table-wrapper h-100 bg-gray mb-3">
      <table
        class="standart-table"
        [class.h-100]="providerDetailsGrid.length === 0"
      >
        <thead class="standart-table-header">
          <tr>
            <th>name</th>
            <th>Id</th>
            <th *ngIf="groupId">group id</th>
            <th class="w-120px"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="providerDetailsGrid.length > 0; else emptyRow">
            <tr
              *ngFor="let detail of providerDetailsGrid"
              [class.disabled]="detail.editing"
            >
              <td
                class="no-wrap"
                [class.text-success]="detail.saved && !isInitialQualifiers"
                [class.text-danger]="detail.error"
              >
                {{ detail.qualifier }} - {{ detail.description }}
              </td>
              <td
                [class.text-success]="detail.saved && !isInitialQualifiers"
                [class.text-danger]="detail.error"
              >
                {{ detail.id }}
              </td>
              <td
                *ngIf="groupId"
                [class.text-success]="detail.saved && !isInitialQualifiers"
                [class.text-danger]="detail.error"
              >
                {{ detail.groupId }}
              </td>
              <td>
                <div class="d-flex align-items-center justify-content-end">
                  <div class="text-danger mr-2" *ngIf="detail.error">
                    <u
                      placement="top"
                      tooltipClass="tooltip-error"
                      container="body"
                      ngbTooltip="Error of saving Identifier. Plese, try agian clicking on Save button"
                    >
                      Error
                    </u>
                  </div>

                  <div
                    ngbDropdown
                    container="body"
                    [class.disabled]="isReadOnly"
                    *ngIf="!detail.error"
                  >
                    <a
                      href="javascript: void(0)"
                      class="standart-link-action"
                      ngbDropdownToggle
                    >
                      <i class="fas fa-chevron-circle-down"></i>
                    </a>

                    <div class="padding-top" ngbDropdownMenu>
                      <div class="dropdown-menu-inside">
                        <button
                          ngbDropdownItem
                          (click)="editProviderDetails(detail)"
                        >
                          Edit Identifier
                        </button>
                        <button
                          [disabled]="detail.saved"
                          ngbDropdownItem
                          (click)="deleteProviderDetails(detail)"
                        >
                          Delete Identifier
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    class="ml-auto text-success align-items-center"
                    *ngIf="detail.saved && !isInitialQualifiers"
                  >
                    <span class="mr-2">Saved</span>
                    <i class="fas fa-check-circle fz-16"></i>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #emptyRow>
  <tr>
    <td colspan="5" class="pt-3 pb-3">
      <empty-state size="sm" title="No results found"></empty-state>
    </td>
  </tr>
</ng-template>
